export const chartData = [
  { name: "Jun", reviewScore: 2.5, percentage: 30 },
  { name: "Jul", reviewScore: 3.0, percentage: 35 },
  { name: "Aug", reviewScore: 3.2, percentage: 40 },
  { name: "Sep", reviewScore: 2.1, percentage: 25 },
  { name: "Oct", reviewScore: 2.5, percentage: 30 },
  { name: "Nov", reviewScore: 2.7, percentage: 32 },
  { name: "Dec", reviewScore: 2.9, percentage: 34 },
  { name: "Jan", reviewScore: 2.8, percentage: 33 },
  { name: "Feb", reviewScore: 2.7, percentage: 32 },
  { name: "Mar", reviewScore: 3.0, percentage: 36 },
  { name: "Apr", reviewScore: 2.0, percentage: 28 },
  { name: "May", reviewScore: 1.5, percentage: 20 },
  { name: "Jun", reviewScore: 3.8, percentage: 45 },
  { name: "Jul", reviewScore: 3.2, percentage: 38 },
  { name: "Aug", reviewScore: 2.8, percentage: 34 },
];
